import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { LampDetails } from '@app/shared/models/lamp-catalogue/lamp-details';
import { AzureBlobStorageService } from '@app/shared/services/api/azure-blob-storage.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-lamp-info-card',
  templateUrl: './lamp-info-card.component.html',
  styleUrls: ['./lamp-info-card.component.scss'],
})
export class LampInfoCardComponent implements OnInit {
  @Input() data: LampDetails = {} as LampDetails;
  @Output() selectedLamp: EventEmitter<LampDetails> = new EventEmitter<LampDetails>();
  @Output() lampToBeDeleted: EventEmitter<LampDetails> = new EventEmitter<LampDetails>();
  public isValidImage = false;

  constructor(private azureBlobStorageService: AzureBlobStorageService) {}

  public ngOnInit() {
    this.isValidImage = !!this.data.imageName || this.data.imageName !== 'undefined';
  }

  public setDefaultImage(): void {
    this.data.imageObservable = this.azureBlobStorageService.getBlobImageSafeUrl(`${environment.tenant}/assets/images/lamps/DefaultLamp.png`);
  }

  public select(lamp: LampDetails): void {
    this.selectedLamp.emit(lamp);
  }

  public delete(lamp: LampDetails): void {
    this.lampToBeDeleted.emit(lamp);
  }
}
